// Can this browser draw the board at all? (D250, analysis A5.)
//
// Until now a player whose device has no WebGL2 emitted `hello` and then nothing — which,
// in every query we have, is indistinguishable from somebody who arrived and chose not to
// play. On a 3D browser game that is not a rounding error, it is a whole class of
// acquisition loss reported as disinterest.
//
// The context is created and IMMEDIATELY thrown away: a browser allows only a handful of
// live GL contexts, and holding a probe's would cost the stage one.

export interface ProbeCanvas {
  getContext(id: string): unknown;
}

/** True when a WebGL2 context can actually be created — asked once, at boot. */
export function webgl2Available(make: () => ProbeCanvas | null = defaultCanvas): boolean {
  try {
    const canvas = make();
    if (!canvas) return false;
    const ctx = canvas.getContext('webgl2');
    if (!ctx) return false;
    // Give the context straight back rather than waiting for the GC (three.js does the same
    // on dispose). A browser hands out very few, and the stage needs the next one.
    (ctx as { getExtension?(name: string): { loseContext?(): void } | null }).getExtension?.('WEBGL_lose_context')?.loseContext?.();
    return true;
  } catch {
    return false; // a browser that throws on getContext has no WebGL2 either
  }
}

function defaultCanvas(): ProbeCanvas | null {
  return typeof document === 'undefined' ? null : document.createElement('canvas');
}
